"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var odometer_1 = __importDefault(require("odometer"));
var Timeline = /** @class */ (function (_super) {
    __extends(Timeline, _super);
    function Timeline() {
        var _this = _super.call(this, constants_1.DATA_TIMELINE) || this;
        if (!_this.getElement()) {
            return _this;
        }
        _this.timeline = _this.getElement();
        _this.timelineYears = _this.getChildElements("[".concat(constants_1.DATA_TIMELINE_YEARS, "]"));
        _this.timelineItems = _this.getChildElements("[".concat(constants_1.DATA_TIMELINE_ITEMS, "]"));
        _this.timelineList = _this.getChildElement("[".concat(constants_1.DATA_TIMELINE_LIST, "]"));
        _this.timelineWrapper = _this.getChildElement("[".concat(constants_1.DATA_TIMELINE_WRAPPER, "]"));
        _this.timelineOdometer = _this.getChildElement("[".concat(constants_1.DATA_ODOMETER, "]"));
        _this.getYears();
        _this.removeDuplicatesBeam();
        //Get timelineYears again after removin duplicates
        _this.timelineYears = _this.getChildElements("[".concat(constants_1.DATA_TIMELINE_YEARS, "]"));
        _this.showTimeline();
        _this.initializeOdometer(parseInt(_this.timelineItems[0].getAttribute('data-timeline-items')));
        window.addEventListener('scroll', function () {
            _this.getYears();
            _this.showTimeline();
        });
        return _this;
    }
    /**
     * Initialize Odometer, odometer.js (JS and CSS library)
     * You need the delcare file in folder types
     * @param activeYear - active Year from getYear() or on first call from constructor,
     * @public
     * Docs: https://github.hubspot.com/odometer/docs/welcome/
     */
    Timeline.prototype.initializeOdometer = function (activeYear) {
        var el = this.timelineOdometer;
        var odometer = new odometer_1.default({
            el: el,
            value: parseInt(this.timelineItems[0].getAttribute('data-timeline-items')),
            duration: 3000,
            format: 'd',
            theme: 'minimal'
        });
        odometer.update(activeYear);
        if (this.timelineIsInViewport(this.timeline)) {
            this.moveBeam(activeYear);
        }
    };
    /**
     * Get all Years of the timeline and call the Odometer method with the last year in viewport = activeYear
     * @private
     */
    Timeline.prototype.getYears = function () {
        var _this = this;
        var activeYear;
        this.timelineItems.forEach(function (element, index) {
            if (_this.itemIsInViewport(element)) {
                activeYear = parseInt(element.getAttribute('data-timeline-items'));
            }
        });
        this.initializeOdometer(activeYear);
    };
    /**
     * Show Timeline if Mask ELement is in Viewport amd remove active state if not, Adding move down or move up to make transition if element is joining or leaving the viewport
     * @private
     */
    Timeline.prototype.showTimeline = function () {
        if (this.timelineIsInViewport(this.timeline) == 'top') {
            this.timelineWrapper.classList.add('move-down');
            this.timelineWrapper.classList.remove('active', 'move-up');
        }
        else if (this.timelineIsInViewport(this.timeline) == 'active') {
            this.timelineWrapper.classList.add('active');
            this.timelineWrapper.classList.remove('move-up', 'move-down');
        }
        else {
            this.timelineWrapper.classList.add('move-up');
            this.timelineWrapper.classList.remove('active', 'move-down');
        }
    };
    /**
     * Check if timeline mask element is top, bottom or in the viewport
     * @param elem - Timeline Mask
     * @private
     */
    Timeline.prototype.timelineIsInViewport = function (elem) {
        var rect = elem.getBoundingClientRect();
        var directionOdometer;
        if (rect.bottom < 500) {
            directionOdometer = 'bottom';
        }
        else if (rect.top <= (((window.innerHeight / 2) || (document.documentElement.clientHeight / 2))) && rect.bottom >= 500) {
            directionOdometer = 'active';
        }
        else {
            directionOdometer = 'top';
        }
        return (directionOdometer);
    };
    /**
     * Check if timeline-item is in the top half of the Viewport
     * @param elem - Timeline Item
     * @private
     */
    Timeline.prototype.itemIsInViewport = function (elem) {
        var rect = elem.getBoundingClientRect();
        return (rect.top <= (((window.innerHeight / 2) || (document.documentElement.clientHeight / 2))));
    };
    /**
     * Move Year Beam via transform matrix inline style
     * Logic: check if activeYear == one year of the beam and adding active state after it.
     * @param activeYear - active Year
     * @private
     */
    Timeline.prototype.moveBeam = function (activeYear) {
        var _this = this;
        var countOfDuplicates = this.countDuplicatesBeam();
        this.timelineYears.forEach(function (element, index) {
            var itemCount = (_this.timelineYears.length - countOfDuplicates) + '20';
            element.classList.remove('active');
            if (activeYear == parseInt(element.getAttribute('data-timeline-years'))) {
                var tomove = parseInt(itemCount) - (index * 96) - (_this.timelineYears.length - countOfDuplicates) * ((_this.timelineYears.length - countOfDuplicates) / 6.25);
                element.classList.add('active');
                _this.timelineList.style.transform = 'matrix(1, 0, 0, 1, 0, ' + tomove + ')';
            }
        });
    };
    /**
     * Removin duplicates out of the time beam
     * @private
     */
    Timeline.prototype.removeDuplicatesBeam = function () {
        var result = [];
        this.timelineYears.forEach(function (element, index) {
            var elementYear = parseInt(element.getAttribute('data-timeline-years'));
            if (result.indexOf(elementYear) === -1) {
                result.push(elementYear);
            }
            else {
                element.remove();
            }
        });
        return result;
    };
    /**
     * count duplicates out of the time beam
     * @private
     */
    Timeline.prototype.countDuplicatesBeam = function () {
        var countOfDuplicates = 0;
        var result = [];
        this.timelineYears.forEach(function (element, index) {
            var elementYear = parseInt(element.getAttribute('data-timeline-years'));
            if (result.indexOf(elementYear) === -1) {
                result.push(elementYear);
            }
            else {
                countOfDuplicates++;
            }
        });
        return countOfDuplicates;
    };
    return Timeline;
}(abstractComponent_1.default));
exports.default = Timeline;
